module.exports = __webpack_public_path__ + "img/L_1H.c03eb9a9.png";